import React from 'react'

import { ZariContext } from '_zari/context'
import { Table } from '_zari/core'

import * as CajaChicaService from 'services/cajaChica.service'

import * as Rows from './rows'

const DocumentosTable = ({ idTituloViatico, mostrarNuevoDocSection, mostrarNuevoSinDocSection }) => {
  const __zariContext = React.useContext(ZariContext)

  const [listaDocumentos, setListaDocumentos] = React.useState([])

  const reloadTable = React.useCallback(() => {
    CajaChicaService.obtenerxIdTituloViatico(idTituloViatico)
      .then(({ data }) => {
        setListaDocumentos(data)
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
  }, [__zariContext, idTituloViatico])

  React.useEffect(() => {
    reloadTable()
  }, [reloadTable])

  return (
    <Table
      containerId='lista-documentos-asignados-viaticos'
      filas={listaDocumentos}
      headRows={[
        { label: 'TIPO DOC.' },
        { label: 'SERIE DOC.' },
        { label: 'NUM DOC.' },
        { label: 'GLOSA' },
        { label: 'MONEDA' },
        { label: 'MONTO' },
        { label: '' }
      ]}
      maxRowsShown={10}
      rowTemplate={(row, k) => (
        <Rows.MainRow
          key={k}
          row={row}
          mostrarNuevoDocSection={mostrarNuevoDocSection}
          mostrarNuevoSinDocSection={mostrarNuevoSinDocSection}
          reloadTable={reloadTable}
        />
      )}
    />
  )
}

export default React.memo(DocumentosTable)
